import { PunchBanner } from './PunchBanner.jsx';
import { KnowledgeDripCard } from './KnowledgeDripCard.jsx';
import { timeclockEnabled } from '../lib/flags.js';

export function HomeLanding({ user, location, completed, total, pct, today, onOpenReports }) {
  const firstName = user?.name ? user.name.split(' ')[0] : '';
  return (
    <div className="space-y-3">
      <div className="card">
        <div className="text-base font-semibold mb-1">Welcome, {firstName}</div>
        <div className="text-sm text-gray-500">{location?.name} · {today}</div>
      </div>
      {/* Clock-in retired 2026-07-29 — Square is the time clock. */}
      {timeclockEnabled() && <PunchBanner user={user} />}
      {/* Knowledge Drip: one card per day; self-hides when off/acked/empty. */}
      <KnowledgeDripCard mode="home" user={user} />
      <div className="card">
        <div style={{ fontSize: 13, fontWeight: 600, color: '#212121', marginBottom: 8 }}>
          Today's task progress
        </div>
        <div className="flex items-center gap-3">
          <div style={{ flex: 1, height: 8, background: '#E8E8E8', borderRadius: 4 }}>
            <div style={{ width: `${pct}%`, height: '100%', background: 'var(--forest)', borderRadius: 4 }} />
          </div>
          <span className="text-xs font-semibold text-gray-600">{completed}/{total} · {pct}%</span>
        </div>
      </div>
      <div className="card">
        <div style={{ fontSize: 13, fontWeight: 600, color: '#212121', marginBottom: 8 }}>Reports</div>
        <div className="text-sm text-gray-500 mb-3">
          {window.EmpireRoles.isOwner(user)
            ? 'Birdseye (cross-location), Daily, This Week, and Year live under Home.'
            : 'Daily, This Week, and Year sales dashboards live under Home.'}
        </div>
        <button className="btn-primary" onClick={onOpenReports}>
          {window.EmpireRoles.isOwner(user) ? 'Open Birdseye →' : 'Open Daily →'}
        </button>
      </div>
    </div>
  );
}
